"use strict";

require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FIXED_HEADER_CONTAINER_ID = exports.FIXED_FOOTER_CONTAINER_ID = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Separator = require("../../complex/Separator");
var _core = require("../../core");
var _Loader = require("../../core/Loader");
var _UNSAFE_Accordion = _interopRequireDefault(require("../UNSAFE_Accordion"));
var _UNSAFE_Arrow = require("../UNSAFE_Arrow");
var _UNSAFE_Responsive = _interopRequireDefault(require("../UNSAFE_Responsive"));
require("./DashboardLayoutWrapperStyle.css");
var _FixedHeaderFooterPortalContainer = _interopRequireDefault(require("./FixedHeaderFooterPortalContainer"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _Layout = _interopRequireDefault(require("./Layout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1tka2p34v() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/DashboardLayoutWrapper.tsx";
  var hash = "8c93beeb07d8eeb91d47773ae71ba46e022d28e8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/DashboardLayoutWrapper.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 27
        },
        end: {
          line: 19,
          column: 28
        }
      },
      "1": {
        start: {
          line: 20,
          column: 20
        },
        end: {
          line: 20,
          column: 47
        }
      },
      "2": {
        start: {
          line: 21,
          column: 27
        },
        end: {
          line: 21,
          column: 61
        }
      },
      "3": {
        start: {
          line: 61,
          column: 41
        },
        end: {
          line: 61,
          column: 71
        }
      },
      "4": {
        start: {
          line: 62,
          column: 41
        },
        end: {
          line: 62,
          column: 71
        }
      },
      "5": {
        start: {
          line: 68,
          column: 70
        },
        end: {
          line: 72,
          column: 3
        }
      },
      "6": {
        start: {
          line: 74,
          column: 47
        },
        end: {
          line: 76,
          column: 3
        }
      },
      "7": {
        start: {
          line: 78,
          column: 56
        },
        end: {
          line: 78,
          column: 89
        }
      },
      "8": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 16
        }
      },
      "9": {
        start: {
          line: 83,
          column: 30
        },
        end: {
          line: 83,
          column: 40
        }
      },
      "10": {
        start: {
          line: 84,
          column: 24
        },
        end: {
          line: 84,
          column: 66
        }
      },
      "11": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 146,
          column: 6
        }
      },
      "12": {
        start: {
          line: 149,
          column: 39
        },
        end: {
          line: 149,
          column: 90
        }
      },
      "13": {
        start: {
          line: 149,
          column: 45
        },
        end: {
          line: 149,
          column: 90
        }
      },
      "14": {
        start: {
          line: 151,
          column: 29
        },
        end: {
          line: 171,
          column: 3
        }
      },
      "15": {
        start: {
          line: 152,
          column: 30
        },
        end: {
          line: 152,
          column: 40
        }
      },
      "16": {
        start: {
          line: 153,
          column: 50
        },
        end: {
          line: 153,
          column: 60
        }
      },
      "17": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 157,
          column: 5
        }
      },
      "18": {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 156,
          column: 33
        }
      },
      "19": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 170,
          column: 6
        }
      },
      "20": {
        start: {
          line: 175,
          column: 30
        },
        end: {
          line: 283,
          column: 3
        }
      },
      "21": {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 182,
          column: 18
        }
      },
      "22": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "23": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 185,
          column: 24
        }
      },
      "24": {
        start: {
          line: 186,
          column: 11
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "25": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 195,
          column: 8
        }
      },
      "26": {
        start: {
          line: 206,
          column: 8
        },
        end: {
          line: 206,
          column: 19
        }
      },
      "27": {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 282,
          column: 6
        }
      },
      "28": {
        start: {
          line: 219,
          column: 14
        },
        end: {
          line: 224,
          column: 19
        }
      },
      "29": {
        start: {
          line: 285,
          column: 36
        },
        end: {
          line: 375,
          column: 3
        }
      },
      "30": {
        start: {
          line: 292,
          column: 8
        },
        end: {
          line: 292,
          column: 18
        }
      },
      "31": {
        start: {
          line: 294,
          column: 4
        },
        end: {
          line: 302,
          column: 5
        }
      },
      "32": {
        start: {
          line: 295,
          column: 6
        },
        end: {
          line: 295,
          column: 24
        }
      },
      "33": {
        start: {
          line: 296,
          column: 11
        },
        end: {
          line: 302,
          column: 5
        }
      },
      "34": {
        start: {
          line: 297,
          column: 6
        },
        end: {
          line: 301,
          column: 8
        }
      },
      "35": {
        start: {
          line: 311,
          column: 8
        },
        end: {
          line: 311,
          column: 19
        }
      },
      "36": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 374,
          column: 6
        }
      },
      "37": {
        start: {
          line: 321,
          column: 18
        },
        end: {
          line: 323,
          column: 22
        }
      },
      "38": {
        start: {
          line: 377,
          column: 26
        },
        end: {
          line: 379,
          column: 3
        }
      },
      "39": {
        start: {
          line: 378,
          column: 4
        },
        end: {
          line: 378,
          column: 44
        }
      },
      "40": {
        start: {
          line: 381,
          column: 26
        },
        end: {
          line: 383,
          column: 3
        }
      },
      "41": {
        start: {
          line: 382,
          column: 4
        },
        end: {
          line: 382,
          column: 43
        }
      },
      "42": {
        start: {
          line: 385,
          column: 27
        },
        end: {
          line: 389,
          column: 3
        }
      },
      "43": {
        start: {
          line: 386,
          column: 4
        },
        end: {
          line: 388,
          column: 5
        }
      },
      "44": {
        start: {
          line: 387,
          column: 6
        },
        end: {
          line: 387,
          column: 27
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 18
          },
          end: {
            line: 147,
            column: 3
          }
        },
        line: 80
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 149,
            column: 39
          },
          end: {
            line: 149,
            column: 40
          }
        },
        loc: {
          start: {
            line: 149,
            column: 45
          },
          end: {
            line: 149,
            column: 90
          }
        },
        line: 149
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 151,
            column: 29
          },
          end: {
            line: 151,
            column: 30
          }
        },
        loc: {
          start: {
            line: 151,
            column: 43
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 151
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 175,
            column: 30
          },
          end: {
            line: 175,
            column: 31
          }
        },
        loc: {
          start: {
            line: 175,
            column: 36
          },
          end: {
            line: 283,
            column: 3
          }
        },
        line: 175
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 218,
            column: 52
          },
          end: {
            line: 218,
            column: 53
          }
        },
        loc: {
          start: {
            line: 219,
            column: 14
          },
          end: {
            line: 224,
            column: 19
          }
        },
        line: 219
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 285,
            column: 36
          },
          end: {
            line: 285,
            column: 37
          }
        },
        loc: {
          start: {
            line: 285,
            column: 42
          },
          end: {
            line: 375,
            column: 3
          }
        },
        line: 285
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 320,
            column: 56
          },
          end: {
            line: 320,
            column: 57
          }
        },
        loc: {
          start: {
            line: 321,
            column: 18
          },
          end: {
            line: 323,
            column: 22
          }
        },
        line: 321
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 377,
            column: 26
          },
          end: {
            line: 377,
            column: 27
          }
        },
        loc: {
          start: {
            line: 377,
            column: 32
          },
          end: {
            line: 379,
            column: 3
          }
        },
        line: 377
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 381,
            column: 26
          },
          end: {
            line: 381,
            column: 27
          }
        },
        loc: {
          start: {
            line: 381,
            column: 32
          },
          end: {
            line: 383,
            column: 3
          }
        },
        line: 381
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 385,
            column: 27
          },
          end: {
            line: 385,
            column: 28
          }
        },
        loc: {
          start: {
            line: 385,
            column: 65
          },
          end: {
            line: 389,
            column: 3
          }
        },
        line: 385
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 84,
            column: 24
          },
          end: {
            line: 84,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 24
          },
          end: {
            line: 84,
            column: 33
          }
        }, {
          start: {
            line: 84,
            column: 37
          },
          end: {
            line: 84,
            column: 66
          }
        }],
        line: 84
      },
      "1": {
        loc: {
          start: {
            line: 90,
            column: 20
          },
          end: {
            line: 90,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 90,
            column: 33
          },
          end: {
            line: 90,
            column: 43
          }
        }, {
          start: {
            line: 90,
            column: 46
          },
          end: {
            line: 90,
            column: 52
          }
        }],
        line: 90
      },
      "2": {
        loc: {
          start: {
            line: 119,
            column: 19
          },
          end: {
            line: 126,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 19
          },
          end: {
            line: 119,
            column: 30
          }
        }, {
          start: {
            line: 120,
            column: 20
          },
          end: {
            line: 125,
            column: 37
          }
        }],
        line: 119
      },
      "3": {
        loc: {
          start: {
            line: 121,
            column: 49
          },
          end: {
            line: 121,
            column: 95
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 121,
            column: 76
          },
          end: {
            line: 121,
            column: 84
          }
        }, {
          start: {
            line: 121,
            column: 87
          },
          end: {
            line: 121,
            column: 95
          }
        }],
        line: 121
      },
      "4": {
        loc: {
          start: {
            line: 131,
            column: 15
          },
          end: {
            line: 135,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 15
          },
          end: {
            line: 131,
            column: 26
          }
        }, {
          start: {
            line: 132,
            column: 16
          },
          end: {
            line: 134,
            column: 22
          }
        }],
        line: 131
      },
      "5": {
        loc: {
          start: {
            line: 138,
            column: 17
          },
          end: {
            line: 140,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 30
          },
          end: {
            line: 138,
            column: 34
          }
        }, {
          start: {
            line: 139,
            column: 18
          },
          end: {
            line: 139,
            column: 90
          }
        }],
        line: 138
      },
      "6": {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 157,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 155
      },
      "7": {
        loc: {
          start: {
            line: 159,
            column: 11
          },
          end: {
            line: 170,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 160,
            column: 6
          },
          end: {
            line: 160,
            column: 43
          }
        }, {
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 169,
            column: 13
          }
        }],
        line: 159
      },
      "8": {
        loc: {
          start: {
            line: 162,
            column: 21
          },
          end: {
            line: 162,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 162,
            column: 37
          },
          end: {
            line: 162,
            column: 55
          }
        }, {
          start: {
            line: 162,
            column: 58
          },
          end: {
            line: 162,
            column: 76
          }
        }],
        line: 162
      },
      "9": {
        loc: {
          start: {
            line: 163,
            column: 9
          },
          end: {
            line: 167,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 163,
            column: 9
          },
          end: {
            line: 163,
            column: 23
          }
        }, {
          start: {
            line: 164,
            column: 10
          },
          end: {
            line: 166,
            column: 17
          }
        }],
        line: 163
      },
      "10": {
        loc: {
          start: {
            line: 168,
            column: 45
          },
          end: {
            line: 168,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 168,
            column: 61
          },
          end: {
            line: 168,
            column: 65
          }
        }, {
          start: {
            line: 168,
            column: 68
          },
          end: {
            line: 168,
            column: 74
          }
        }],
        line: 168
      },
      "11": {
        loc: {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: 186,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }],
        line: 184
      },
      "12": {
        loc: {
          start: {
            line: 186,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 11
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 186
      },
      "13": {
        loc: {
          start: {
            line: 186,
            column: 17
          },
          end: {
            line: 186,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 17
          },
          end: {
            line: 186,
            column: 28
          }
        }, {
          start: {
            line: 186,
            column: 33
          },
          end: {
            line: 186,
            column: 50
          }
        }, {
          start: {
            line: 186,
            column: 54
          },
          end: {
            line: 186,
            column: 70
          }
        }],
        line: 186
      },
      "14": {
        loc: {
          start: {
            line: 222,
            column: 19
          },
          end: {
            line: 222,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 222,
            column: 19
          },
          end: {
            line: 222,
            column: 32
          }
        }, {
          start: {
            line: 222,
            column: 36
          },
          end: {
            line: 222,
            column: 57
          }
        }],
        line: 222
      },
      "15": {
        loc: {
          start: {
            line: 226,
            column: 13
          },
          end: {
            line: 230,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 226,
            column: 13
          },
          end: {
            line: 226,
            column: 46
          }
        }, {
          start: {
            line: 227,
            column: 14
          },
          end: {
            line: 229,
            column: 19
          }
        }],
        line: 226
      },
      "16": {
        loc: {
          start: {
            line: 231,
            column: 13
          },
          end: {
            line: 231,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 231,
            column: 13
          },
          end: {
            line: 231,
            column: 29
          }
        }, {
          start: {
            line: 231,
            column: 33
          },
          end: {
            line: 231,
            column: 39
          }
        }],
        line: 231
      },
      "17": {
        loc: {
          start: {
            line: 232,
            column: 13
          },
          end: {
            line: 239,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 232,
            column: 13
          },
          end: {
            line: 232,
            column: 38
          }
        }, {
          start: {
            line: 233,
            column: 14
          },
          end: {
            line: 238,
            column: 31
          }
        }],
        line: 232
      },
      "18": {
        loc: {
          start: {
            line: 240,
            column: 13
          },
          end: {
            line: 244,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 240,
            column: 13
          },
          end: {
            line: 240,
            column: 45
          }
        }, {
          start: {
            line: 241,
            column: 14
          },
          end: {
            line: 243,
            column: 19
          }
        }],
        line: 240
      },
      "19": {
        loc: {
          start: {
            line: 245,
            column: 13
          },
          end: {
            line: 249,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 13
          },
          end: {
            line: 245,
            column: 44
          }
        }, {
          start: {
            line: 246,
            column: 14
          },
          end: {
            line: 248,
            column: 19
          }
        }],
        line: 245
      },
      "20": {
        loc: {
          start: {
            line: 250,
            column: 13
          },
          end: {
            line: 254,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 250,
            column: 13
          },
          end: {
            line: 250,
            column: 45
          }
        }, {
          start: {
            line: 251,
            column: 14
          },
          end: {
            line: 253,
            column: 19
          }
        }],
        line: 250
      },
      "21": {
        loc: {
          start: {
            line: 255,
            column: 13
          },
          end: {
            line: 259,
            column: 20
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 258,
            column: 14
          },
          end: {
            line: 258,
            column: 20
          }
        }, {
          start: {
            line: 259,
            column: 16
          },
          end: {
            line: 259,
            column: 20
          }
        }],
        line: 255
      },
      "22": {
        loc: {
          start: {
            line: 255,
            column: 13
          },
          end: {
            line: 257,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 255,
            column: 13
          },
          end: {
            line: 255,
            column: 44
          }
        }, {
          start: {
            line: 256,
            column: 12
          },
          end: {
            line: 256,
            column: 44
          }
        }, {
          start: {
            line: 257,
            column: 12
          },
          end: {
            line: 257,
            column: 44
          }
        }],
        line: 255
      },
      "23": {
        loc: {
          start: {
            line: 263,
            column: 13
          },
          end: {
            line: 271,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 263,
            column: 13
          },
          end: {
            line: 263,
            column: 54
          }
        }, {
          start: {
            line: 264,
            column: 14
          },
          end: {
            line: 270,
            column: 19
          }
        }],
        line: 263
      },
      "24": {
        loc: {
          start: {
            line: 294,
            column: 4
          },
          end: {
            line: 302,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 294,
            column: 4
          },
          end: {
            line: 302,
            column: 5
          }
        }, {
          start: {
            line: 296,
            column: 11
          },
          end: {
            line: 302,
            column: 5
          }
        }],
        line: 294
      },
      "25": {
        loc: {
          start: {
            line: 296,
            column: 11
          },
          end: {
            line: 302,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 296,
            column: 11
          },
          end: {
            line: 302,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 296
      },
      "26": {
        loc: {
          start: {
            line: 296,
            column: 17
          },
          end: {
            line: 296,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 296,
            column: 17
          },
          end: {
            line: 296,
            column: 28
          }
        }, {
          start: {
            line: 296,
            column: 33
          },
          end: {
            line: 296,
            column: 50
          }
        }, {
          start: {
            line: 296,
            column: 54
          },
          end: {
            line: 296,
            column: 70
          }
        }],
        line: 296
      },
      "27": {
        loc: {
          start: {
            line: 325,
            column: 17
          },
          end: {
            line: 329,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 325,
            column: 17
          },
          end: {
            line: 325,
            column: 50
          }
        }, {
          start: {
            line: 326,
            column: 18
          },
          end: {
            line: 328,
            column: 22
          }
        }],
        line: 325
      },
      "28": {
        loc: {
          start: {
            line: 330,
            column: 17
          },
          end: {
            line: 330,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 330,
            column: 17
          },
          end: {
            line: 330,
            column: 31
          }
        }, {
          start: {
            line: 330,
            column: 35
          },
          end: {
            line: 330,
            column: 72
          }
        }],
        line: 330
      },
      "29": {
        loc: {
          start: {
            line: 331,
            column: 17
          },
          end: {
            line: 338,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 17
          },
          end: {
            line: 331,
            column: 42
          }
        }, {
          start: {
            line: 332,
            column: 18
          },
          end: {
            line: 337,
            column: 35
          }
        }],
        line: 331
      },
      "30": {
        loc: {
          start: {
            line: 339,
            column: 17
          },
          end: {
            line: 343,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 339,
            column: 17
          },
          end: {
            line: 339,
            column: 49
          }
        }, {
          start: {
            line: 340,
            column: 18
          },
          end: {
            line: 342,
            column: 23
          }
        }],
        line: 339
      },
      "31": {
        loc: {
          start: {
            line: 344,
            column: 17
          },
          end: {
            line: 350,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 344,
            column: 17
          },
          end: {
            line: 344,
            column: 48
          }
        }, {
          start: {
            line: 345,
            column: 18
          },
          end: {
            line: 349,
            column: 23
          }
        }],
        line: 344
      },
      "32": {
        loc: {
          start: {
            line: 351,
            column: 17
          },
          end: {
            line: 353,
            column: 24
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 352,
            column: 18
          },
          end: {
            line: 352,
            column: 55
          }
        }, {
          start: {
            line: 353,
            column: 20
          },
          end: {
            line: 353,
            column: 24
          }
        }],
        line: 351
      },
      "33": {
        loc: {
          start: {
            line: 351,
            column: 17
          },
          end: {
            line: 351,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 351,
            column: 17
          },
          end: {
            line: 351,
            column: 48
          }
        }, {
          start: {
            line: 351,
            column: 52
          },
          end: {
            line: 351,
            column: 84
          }
        }],
        line: 351
      },
      "34": {
        loc: {
          start: {
            line: 357,
            column: 17
          },
          end: {
            line: 363,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 357,
            column: 17
          },
          end: {
            line: 357,
            column: 58
          }
        }, {
          start: {
            line: 358,
            column: 18
          },
          end: {
            line: 362,
            column: 22
          }
        }],
        line: 357
      },
      "35": {
        loc: {
          start: {
            line: 386,
            column: 4
          },
          end: {
            line: 388,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 386,
            column: 4
          },
          end: {
            line: 388,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 386
      },
      "36": {
        loc: {
          start: {
            line: 386,
            column: 8
          },
          end: {
            line: 386,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 386,
            column: 8
          },
          end: {
            line: 386,
            column: 23
          }
        }, {
          start: {
            line: 386,
            column: 27
          },
          end: {
            line: 386,
            column: 63
          }
        }],
        line: 386
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8c93beeb07d8eeb91d47773ae71ba46e022d28e8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1tka2p34v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1tka2p34v();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */ /* eslint-disable jsx-a11y/click-events-have-key-events */
var MAX_NUM_LEAD_LINKS = (cov_1tka2p34v().s[0]++, 3);
var NAV_MENU_ID = (cov_1tka2p34v().s[1]++, 'dashboard-layout-nav-menu');
var NAV_MENU_BUTTON_ID = (cov_1tka2p34v().s[2]++, 'dashboard-layout-nav-menu-button');

/** @deprecated */

var FIXED_FOOTER_CONTAINER_ID = exports.FIXED_FOOTER_CONTAINER_ID = (cov_1tka2p34v().s[3]++, 'od-fixed-footer-container-id');
var FIXED_HEADER_CONTAINER_ID = exports.FIXED_HEADER_CONTAINER_ID = (cov_1tka2p34v().s[4]++, 'od-fixed-header-container-id');
var DashboardLayoutWrapper = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardLayoutWrapper, _React$Component);
  function DashboardLayoutWrapper() {
    var _this;
    _classCallCheck(this, DashboardLayoutWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DashboardLayoutWrapper, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", (cov_1tka2p34v().s[6]++, {
      showMobileNav: false
    }));
    _defineProperty(_assertThisInitialized(_this), "overlayRef", (cov_1tka2p34v().s[7]++, /*#__PURE__*/_react["default"].createRef()));
    _defineProperty(_assertThisInitialized(_this), "renderResponsiveNavControl", (cov_1tka2p34v().s[12]++, function () {
      cov_1tka2p34v().f[1]++;
      cov_1tka2p34v().s[13]++;
      return /*#__PURE__*/_react["default"].createElement(_UNSAFE_Responsive["default"], {
        render: _this.renderNavControl
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "renderNavControl", (cov_1tka2p34v().s[14]++, function (_ref) {
      var gtLG = _ref.gtLG;
      cov_1tka2p34v().f[2]++;
      var _ref2 = (cov_1tka2p34v().s[15]++, _this.state),
        showMobileNav = _ref2.showMobileNav;
      var _ref3 = (cov_1tka2p34v().s[16]++, _this.props),
        mobileNavTitle = _ref3.mobileNavTitle,
        renderAccountInfo = _ref3.renderAccountInfo;
      cov_1tka2p34v().s[17]++;
      if (renderAccountInfo) {
        cov_1tka2p34v().b[6][0]++;
        cov_1tka2p34v().s[18]++;
        return renderAccountInfo();
      } else {
        cov_1tka2p34v().b[6][1]++;
      }
      cov_1tka2p34v().s[19]++;
      return gtLG ? (cov_1tka2p34v().b[7][0]++, /*#__PURE__*/_react["default"].createElement("div", null, _this.renderAccountMenu())) : (cov_1tka2p34v().b[7][1]++, /*#__PURE__*/_react["default"].createElement(_core.Flex, {
        onClick: showMobileNav ? (cov_1tka2p34v().b[8][0]++, _this.hideMobileNav) : (cov_1tka2p34v().b[8][1]++, _this.showMobileNav)
      }, (cov_1tka2p34v().b[9][0]++, mobileNavTitle) && (cov_1tka2p34v().b[9][1]++, /*#__PURE__*/_react["default"].createElement(_core.Text, {
        pr: 4,
        color: "neutrals100",
        fontWeight: "bold"
      }, _this.props.mobileNavTitle)), /*#__PURE__*/_react["default"].createElement(_UNSAFE_Arrow.UNSAFE_Arrowhead, {
        rotationDirection: showMobileNav ? (cov_1tka2p34v().b[10][0]++, 'up') : (cov_1tka2p34v().b[10][1]++, 'down'),
        size: 4
      })));
    }));
    // copied from legacy FullHeader for consistency
    // uses different template variables
    _defineProperty(_assertThisInitialized(_this), "renderAccountMenu", (cov_1tka2p34v().s[20]++, function () {
      cov_1tka2p34v().f[3]++;
      var _ref4 = (cov_1tka2p34v().s[21]++, _this.props),
        accountInfo = _ref4.accountInfo,
        isLoadingAccountInfo = _ref4.isLoadingAccountInfo,
        onLogout = _ref4.onLogout,
        opendoorDomain = _ref4.opendoorDomain,
        opendoorPartnershipsDomain = _ref4.opendoorPartnershipsDomain;
      cov_1tka2p34v().s[22]++;
      if (isLoadingAccountInfo) {
        cov_1tka2p34v().b[11][0]++;
        cov_1tka2p34v().s[23]++;
        return /*#__PURE__*/_react["default"].createElement(_Loader.Loader, null);
      } else {
        cov_1tka2p34v().b[11][1]++;
        cov_1tka2p34v().s[24]++;
        if (!((cov_1tka2p34v().b[13][0]++, accountInfo) && ((cov_1tka2p34v().b[13][1]++, accountInfo.email) || (cov_1tka2p34v().b[13][2]++, accountInfo.name)))) {
          cov_1tka2p34v().b[12][0]++;
          cov_1tka2p34v().s[25]++;
          return /*#__PURE__*/_react["default"].createElement("ul", {
            className: "account-tab"
          }, /*#__PURE__*/_react["default"].createElement("li", {
            className: "primary-nav-item"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            className: "account-link",
            href: "".concat(opendoorDomain, "/login")
          }, "Sign in")));
        } else {
          cov_1tka2p34v().b[12][1]++;
        }
      }
      var _ref5 = (cov_1tka2p34v().s[26]++, accountInfo),
        hasResaleClosingDashboard = _ref5.hasResaleClosingDashboard,
        hasPartnershipReferralDashboard = _ref5.hasPartnershipReferralDashboard,
        hasPartnershipReportingDashboard = _ref5.hasPartnershipReportingDashboard,
        hasPartnershipDeveloperDashboard = _ref5.hasPartnershipDeveloperDashboard,
        hasPartnershipNotificationPreferencesPage = _ref5.hasPartnershipNotificationPreferencesPage,
        leads = _ref5.leads,
        name = _ref5.name;
      cov_1tka2p34v().s[27]++;
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: "account-tab"
      }, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-item"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "hidden-xs-down"
      }, "Welcome\xA0"), /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorDomain, "/account"),
        className: "account-link"
      }, name)), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "menu primary-nav-submenu account"
      }, leads.slice(0, MAX_NUM_LEAD_LINKS).map(function (_ref6) {
        var url = _ref6.url,
          readableState = _ref6.readableState,
          streetName = _ref6.streetName;
        cov_1tka2p34v().f[4]++;
        cov_1tka2p34v().s[28]++;
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: url,
          className: "primary-nav-submenu-item"
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: url
        }, streetName, (cov_1tka2p34v().b[14][0]++, readableState) && (cov_1tka2p34v().b[14][1]++, " (".concat(readableState, ")"))));
      }), (cov_1tka2p34v().b[15][0]++, leads.length > MAX_NUM_LEAD_LINKS) && (cov_1tka2p34v().b[15][1]++, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorDomain, "/properties")
      }, "More"))), (cov_1tka2p34v().b[16][0]++, leads.length > 0) && (cov_1tka2p34v().b[16][1]++, /*#__PURE__*/_react["default"].createElement("hr", null)), (cov_1tka2p34v().b[17][0]++, hasResaleClosingDashboard) && (cov_1tka2p34v().b[17][1]++, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorDomain, "/closing-dashboard")
      }, "Closing dash")), /*#__PURE__*/_react["default"].createElement("hr", null))), (cov_1tka2p34v().b[18][0]++, hasPartnershipReportingDashboard) && (cov_1tka2p34v().b[18][1]++, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorPartnershipsDomain, "/reports")
      }, "Reporting Dashboard"))), (cov_1tka2p34v().b[19][0]++, hasPartnershipReferralDashboard) && (cov_1tka2p34v().b[19][1]++, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorPartnershipsDomain, "/referral-dashboard")
      }, "Referral Dashboard"))), (cov_1tka2p34v().b[20][0]++, hasPartnershipDeveloperDashboard) && (cov_1tka2p34v().b[20][1]++, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorPartnershipsDomain, "/developer")
      }, "Developer Dashboard"))), (cov_1tka2p34v().b[22][0]++, hasPartnershipReferralDashboard) || (cov_1tka2p34v().b[22][1]++, hasPartnershipReportingDashboard) || (cov_1tka2p34v().b[22][2]++, hasPartnershipDeveloperDashboard) ? (cov_1tka2p34v().b[21][0]++, /*#__PURE__*/_react["default"].createElement("hr", null)) : (cov_1tka2p34v().b[21][1]++, null), /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorDomain, "/account")
      }, "Account")), (cov_1tka2p34v().b[23][0]++, hasPartnershipNotificationPreferencesPage) && (cov_1tka2p34v().b[23][1]++, /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "".concat(opendoorPartnershipsDomain, "/referral-dashboard/subscription-preferences")
      }, "Email Preferences"))), /*#__PURE__*/_react["default"].createElement("li", {
        className: "primary-nav-submenu-item"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: onLogout
      }, "Sign out")))));
    }));
    _defineProperty(_assertThisInitialized(_this), "renderMobileAccountMenu", (cov_1tka2p34v().s[29]++, function () {
      cov_1tka2p34v().f[5]++;
      var _ref7 = (cov_1tka2p34v().s[30]++, _this.props),
        accountInfo = _ref7.accountInfo,
        isLoadingAccountInfo = _ref7.isLoadingAccountInfo,
        onLogout = _ref7.onLogout,
        opendoorDomain = _ref7.opendoorDomain,
        opendoorPartnershipsDomain = _ref7.opendoorPartnershipsDomain;
      cov_1tka2p34v().s[31]++;
      if (isLoadingAccountInfo) {
        cov_1tka2p34v().b[24][0]++;
        cov_1tka2p34v().s[32]++;
        return /*#__PURE__*/_react["default"].createElement(_Loader.Loader, null);
      } else {
        cov_1tka2p34v().b[24][1]++;
        cov_1tka2p34v().s[33]++;
        if (!((cov_1tka2p34v().b[26][0]++, accountInfo) && ((cov_1tka2p34v().b[26][1]++, accountInfo.email) || (cov_1tka2p34v().b[26][2]++, accountInfo.name)))) {
          cov_1tka2p34v().b[25][0]++;
          cov_1tka2p34v().s[34]++;
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "od-dashboard-layout-wrapper__mobile-sign-in"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorDomain, "/login")
          }, "Sign in"));
        } else {
          cov_1tka2p34v().b[25][1]++;
        }
      }
      var _ref8 = (cov_1tka2p34v().s[35]++, accountInfo),
        hasResaleClosingDashboard = _ref8.hasResaleClosingDashboard,
        hasPartnershipReferralDashboard = _ref8.hasPartnershipReferralDashboard,
        hasPartnershipReportingDashboard = _ref8.hasPartnershipReportingDashboard,
        hasPartnershipNotificationPreferencesPage = _ref8.hasPartnershipNotificationPreferencesPage,
        leads = _ref8.leads,
        name = _ref8.name;
      cov_1tka2p34v().s[36]++;
      return /*#__PURE__*/_react["default"].createElement(_UNSAFE_Accordion["default"], {
        noBorder: true,
        items: [{
          body: /*#__PURE__*/_react["default"].createElement("ul", {
            className: "od-dashboard-layout-wrapper__mobile-account-menu"
          }, leads.slice(0, MAX_NUM_LEAD_LINKS).map(function (_ref9) {
            var url = _ref9.url,
              streetName = _ref9.streetName;
            cov_1tka2p34v().f[6]++;
            cov_1tka2p34v().s[37]++;
            return /*#__PURE__*/_react["default"].createElement("a", {
              key: url,
              href: url
            }, /*#__PURE__*/_react["default"].createElement("li", null, streetName));
          }), (cov_1tka2p34v().b[27][0]++, leads.length > MAX_NUM_LEAD_LINKS) && (cov_1tka2p34v().b[27][1]++, /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorDomain, "/properties")
          }, /*#__PURE__*/_react["default"].createElement("li", null, "More"))), (cov_1tka2p34v().b[28][0]++, !!leads.length) && (cov_1tka2p34v().b[28][1]++, /*#__PURE__*/_react["default"].createElement(_Separator.Separator, {
            marginVertical: "medium"
          })), (cov_1tka2p34v().b[29][0]++, hasResaleClosingDashboard) && (cov_1tka2p34v().b[29][1]++, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorDomain, "/closing-dashboard")
          }, /*#__PURE__*/_react["default"].createElement("li", null, "Closing dash")), /*#__PURE__*/_react["default"].createElement(_Separator.Separator, {
            marginVertical: "medium"
          }))), (cov_1tka2p34v().b[30][0]++, hasPartnershipReportingDashboard) && (cov_1tka2p34v().b[30][1]++, /*#__PURE__*/_react["default"].createElement("li", {
            className: "primary-nav-submenu-item"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorPartnershipsDomain, "/reports")
          }, "Reporting Dashboard"))), (cov_1tka2p34v().b[31][0]++, hasPartnershipReferralDashboard) && (cov_1tka2p34v().b[31][1]++, /*#__PURE__*/_react["default"].createElement("li", {
            className: "primary-nav-submenu-item"
          }, /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorPartnershipsDomain, "/referral-dashboard")
          }, "Referral Dashboard"))), (cov_1tka2p34v().b[33][0]++, hasPartnershipReferralDashboard) || (cov_1tka2p34v().b[33][1]++, hasPartnershipReportingDashboard) ? (cov_1tka2p34v().b[32][0]++, /*#__PURE__*/_react["default"].createElement(_Separator.Separator, {
            marginVertical: "medium"
          })) : (cov_1tka2p34v().b[32][1]++, null), /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorDomain, "/account")
          }, /*#__PURE__*/_react["default"].createElement("li", null, "Account")), (cov_1tka2p34v().b[34][0]++, hasPartnershipNotificationPreferencesPage) && (cov_1tka2p34v().b[34][1]++, /*#__PURE__*/_react["default"].createElement("a", {
            href: "".concat(opendoorPartnershipsDomain, "/referral-dashboard/subscription-preferences")
          }, /*#__PURE__*/_react["default"].createElement("li", null, "Email Preferences"))), /*#__PURE__*/_react["default"].createElement("button", {
            className: "button link no-padding",
            onClick: onLogout
          }, /*#__PURE__*/_react["default"].createElement("li", null, "Sign out"))),
          id: name,
          title: name
        }]
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "hideMobileNav", (cov_1tka2p34v().s[38]++, function () {
      cov_1tka2p34v().f[7]++;
      cov_1tka2p34v().s[39]++;
      _this.setState({
        showMobileNav: false
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "showMobileNav", (cov_1tka2p34v().s[40]++, function () {
      cov_1tka2p34v().f[8]++;
      cov_1tka2p34v().s[41]++;
      _this.setState({
        showMobileNav: true
      });
    }));
    _defineProperty(_assertThisInitialized(_this), "onOverlayClick", (cov_1tka2p34v().s[42]++, function (e) {
      cov_1tka2p34v().f[9]++;
      cov_1tka2p34v().s[43]++;
      if ((cov_1tka2p34v().b[36][0]++, _this.overlayRef) && (cov_1tka2p34v().b[36][1]++, _this.overlayRef.current === e.target)) {
        cov_1tka2p34v().b[35][0]++;
        cov_1tka2p34v().s[44]++;
        _this.hideMobileNav();
      } else {
        cov_1tka2p34v().b[35][1]++;
      }
    }));
    return _this;
  }
  _createClass(DashboardLayoutWrapper, [{
    key: "render",
    value: function render() {
      cov_1tka2p34v().f[0]++;
      var _ref10 = (cov_1tka2p34v().s[8]++, this.props),
        children = _ref10.children,
        analyticsName = _ref10.analyticsName,
        footerType = _ref10.footerType,
        headerType = _ref10.headerType,
        renderLogo = _ref10.renderLogo,
        renderNav = _ref10.renderNav,
        onBackClick = _ref10.onBackClick;
      var _ref11 = (cov_1tka2p34v().s[9]++, this.state),
        showMobileNav = _ref11.showMobileNav;
      var renderedNav = (cov_1tka2p34v().s[10]++, (cov_1tka2p34v().b[0][0]++, renderNav) && (cov_1tka2p34v().b[0][1]++, renderNav(this.hideMobileNav)));
      cov_1tka2p34v().s[11]++;
      return /*#__PURE__*/_react["default"].createElement(_Layout["default"], {
        analyticsName: analyticsName,
        fixedHeader: true,
        footerType: footerType ? (cov_1tka2p34v().b[1][0]++, footerType) : (cov_1tka2p34v().b[1][1]++, 'NONE'),
        headerType: headerType,
        renderAccountMenu: this.renderResponsiveNavControl,
        renderLogo: renderLogo,
        onBackClick: onBackClick
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__content"
      }, /*#__PURE__*/_react["default"].createElement(_FixedHeaderFooterPortalContainer["default"], {
        fixedFooterContainerId: FIXED_FOOTER_CONTAINER_ID,
        fixedHeaderContainerId: FIXED_HEADER_CONTAINER_ID
      }, /*#__PURE__*/_react["default"].createElement("nav", {
        "aria-labelledby": NAV_MENU_BUTTON_ID,
        className: (0, _classnames["default"])('od-dashboard-layout-wrapper__mobile-menu-container hidden-lg-up', {
          'od-dashboard-layout-wrapper__mobile-menu-container--visible': showMobileNav
        }),
        id: NAV_MENU_ID,
        onClick: this.onOverlayClick,
        ref: this.overlayRef,
        role: "menu"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__mobile-menu"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__mobile-sub-menu"
      }, this.renderMobileAccountMenu()), (cov_1tka2p34v().b[2][0]++, renderedNav) && (cov_1tka2p34v().b[2][1]++, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Separator.Separator, {
        marginVertical: this.state.showMobileNav ? (cov_1tka2p34v().b[3][0]++, 'xSmall') : (cov_1tka2p34v().b[3][1]++, 'medium')
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__mobile-sub-menu"
      }, renderedNav))))), (cov_1tka2p34v().b[4][0]++, renderedNav) && (cov_1tka2p34v().b[4][1]++, /*#__PURE__*/_react["default"].createElement("div", {
        className: "hidden-lg-down od-dashboard-layout-wrapper__nav-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__nav"
      }, renderedNav))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__children-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "od-dashboard-layout-wrapper__children"
      }, children), footerType ? (cov_1tka2p34v().b[5][0]++, null) : (cov_1tka2p34v().b[5][1]++, /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
        analyticsName: "".concat(analyticsName, "-footer"),
        centerAlign: false
      })))))));
    }
  }]);
  return DashboardLayoutWrapper;
}((_react["default"].Component));
_defineProperty(DashboardLayoutWrapper, "defaultProps", (cov_1tka2p34v().s[5]++, {
  headerType: 'HIDE_NAV',
  opendoorDomain: '',
  opendoorPartnershipsDomain: 'https://partner.opendoor.com'
}));